module.exports = __webpack_public_path__ + "static/logo-9803ae14a2895d64b48d5f7c9b1a6fdf.svg";